module.exports = __webpack_public_path__ + "static/media/DJI_0009 1.8ce9a7b9.png";